var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"table-data",class:_vm.modifyClasses},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }